import { RefreshButton, TopToolbar } from 'ra-ui-materialui';

const AuditListActions = () => (
    <TopToolbar sx={{ display: 'flex', alignItems: 'center' }}>
        <RefreshButton
            data-cy='refresh-button'
            style={{
                paddingLeft: '12px',
                paddingRight: '12px',
            }}
        />
    </TopToolbar>
);

export default AuditListActions;
